import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal",
  tabindex: "-1",
  role: "dialog",
  ref: "subscribe-newsletter-modal",
  id: "subscribe_newsletter_modal"
}

import {computed, onMounted, reactive, useTemplateRef, watch} from "vue";
import {useRouter} from "vue-router";
import Modal from "bootstrap/js/dist/modal";

import {useMainStore} from "@/stores/mainStore";


interface State {
    isUserLogged: boolean
}



export default /*@__PURE__*/_defineComponent({
  __name: 'SubscribeNewsletterModal',
  setup(__props) {

const router = useRouter();
const modalElement = useTemplateRef<HTMLDivElement>('subscribe-newsletter-modal')

const mainStore = useMainStore();

let myModal: Modal;
let timeOutId: number | null = null


const state: State = reactive({
    isUserLogged: computed<boolean>(() => !!mainStore.getLoggedUser),
})


onMounted(() => {
    if (modalElement.value) {
        myModal = new Modal(modalElement.value, {
            keyboard: false
        })
        // console.debug('newsletter modal mounted ')
        const sessionInvite = sessionStorage.getItem('newsletterInvite')

        if (!sessionInvite) {
            // console.debug('invite not found, setting the timer for the invite... ')
            timeOutId = setTimeout(() => {
                myModal.show()
                sessionStorage.setItem('newsletterInvite', 'true')
            }, 2 * 60 * 1000)
        }

    }
})

watch(() => state.isUserLogged,
    (value) => {
        if (value && timeOutId) {
            // console.debug('user logged in, cleaning timeout...')
            clearTimeout(timeOutId)
        }
    }
)


const subscribeHandler = () => {
    myModal.hide();
    router.push({name: 'home', hash: '#newsletterForm'})
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal-dialog modal-lg",
      role: "document"
    }, [
      _createElementVNode("div", { class: "modal-content" }, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("h4", { class: "modal-title" }, " Get weekly update on news from Mergerfilers "),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close btn-close-white",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", { class: "modal-footer mt-5 justify-content-center" }, [
          _cache[0] || (_cache[0] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, " Not now ", -1)),
          _createElementVNode("button", {
            type: "button",
            onClick: subscribeHandler,
            class: "btn btn-primary"
          }, " Get updates ")
        ])
      ])
    ])
  ], 512))
}
}

})